import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import { useEffect, type ReactNode } from "react";
import { useLocation } from "wouter";
import { Footer } from "./Footer";
import { AdminHeader } from "./Header/AdminHeader";
import { Header } from "./Header/Header";

export function Layout({ children }: { children: ReactNode }) {
  const [pathname] = useLocation();
  const isAdminRoute = pathname.startsWith("/admin");

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [pathname]);

  return (
    <Container
      disableGutters
      maxWidth={false}
      sx={{
        width: "100%",
        height: "100%",
        padding: 0,
        position: "relative",
        background: "var(--mdai-background-default)",
        backgroundSize: "cover",
        minHeight: "100vh",
      }}
    >
      <CssBaseline />
      {isAdminRoute ? <AdminHeader /> : <Header />}
      <Container sx={{ px: { sm: 3, lg: 8 } }} maxWidth={"lg"}>
        {children}
      </Container>
      {!isAdminRoute && <Footer />}
    </Container>
  );
}
